import { Component, Inject, OnDestroy, ViewEncapsulation } from "@angular/core";
import { FormControl, Validators } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { fuseAnimations } from "@fuse/animations";
import { ClienteModel } from "app/clientes/models/cliente.model";
import { DIALOG_CANCEL_ACTION } from "app/shared/dialog-constants";
import { Subject, takeUntil } from "rxjs";
import { BaseV2Component } from "../../base-module/base-component-v2/base-component-v2.component";
import { LoadingTeste } from "../../base-module/base-component/base.component";
import { AuthService } from "../../base-module/base-service/auth.service";
import { BoletaPayload } from "../models/movimentacao-boleta/boleta-payload";
import { BoletaService } from "../services/boleta.service";

export interface DialogData {
    id: number;
    cliente: ClienteModel;
    valor: number;
    data_operacao: string;
    status_id: number;
    observacao: string;
    tipo_boleta: number;
    acao_comercial_id: number;
    vlr_executado: number;
    estrategia_id: number;
    valor_total: number;
    estrategia: string;
}

@Component({
    selector: "app-confirma-boleta",
    templateUrl: "./confirma-boleta.component.html",
    styleUrls: ["./confirma-boleta.component.scss"],
    encapsulation: ViewEncapsulation.None,
    animations: fuseAnimations,
})
export class ConfirmaBoletaComponent extends BaseV2Component implements OnDestroy {
    private readonly destroy$ = new Subject<void>();

    nome = new FormControl("", [Validators.required]);

    loadingLocal: MatDialogRef<LoadingTeste> | null = null;

    constructor(
        public _service: BoletaService,
        public dialog: MatDialog,
        override snackBar: MatSnackBar,
        private loading: MatDialog,
        public authService: AuthService,
        public dialogRef: MatDialogRef<ConfirmaBoletaComponent>,
        @Inject(MAT_DIALOG_DATA) public data: DialogData
    ) {
        super(dialog, snackBar);
    }

    /**
     * Emite sinal de destruição e completa o subject para limpar todas as subscriptions
     */
    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    /**
     * Cancela e fecha o diálogo de confirmação
     */
    onNoClick(): void {
        this.dialogRef.close(DIALOG_CANCEL_ACTION);
    }

    /**
     * Abre loagind
     */
    openLoadingLocal(): void {
        this.loadingLocal = this.loading.open(LoadingTeste, {
            width: "150px",
            disableClose: true,
        });
    }

    /**
     * Fecha loagind
     */
    closeLoadingLocal(): void {
        if (this.loadingLocal !== null) {
            this.loadingLocal.close();
        }
    }

    /**
     * Verifica se o formulário de confirmação é inválido
     * @returns true se inválido
     */
    isInvalidForm(): boolean {
        if (!this.nome.valid) {
            return true;
        }

        return false;
    }

    /**
     * Persiste a boleta (cria ou atualiza conforme ID)
     */
    salvar(): void {
        this.openLoading();

        const boletaPayload: BoletaPayload = {
            cliente_id: this.data.cliente.id,
            valor: this.data.valor,
            valor_dinheiro_novo: this.data.valor,
            observacao: this.data.observacao,
            data_operacao: this.data.data_operacao,
            status_id: this.data.status_id,
            tipo_boleta: this.data.tipo_boleta,
            acao_comercial_id: this.data.acao_comercial_id,
            vlr_executado: this.data.vlr_executado,
            estrategia_id: this.data.estrategia_id,
        };

        if (!this.data.id) {
            this._service
                .create(boletaPayload)
                .pipe(takeUntil(this.destroy$))
                .subscribe({
                    next: (data) => {
                        this.closeLoading();
                        this.dialogRef.close(data);
                    },
                    error: (error) => {
                        this.closeLoading();
                        this.showSnackMessage(error.error.message, "error");
                    },
                    complete: () => {
                        this.closeLoading();
                    },
                });
        } else {
            this._service
                .update(this.data.id, boletaPayload)
                .pipe(takeUntil(this.destroy$))
                .subscribe({
                    next: (data) => {
                        this.closeLoading();
                        this.dialogRef.close(data);
                    },
                    error: (error) => {
                        this.closeLoading();
                        this.showSnackMessage(error.error.message, "error");
                    },
                    complete: () => {
                        this.closeLoading();
                    },
                });
        }
    }
}
